var map = {
	"./img_0.png": 666,
	"./img_1.png": 667,
	"./img_2.png": 668,
	"./img_3.png": 669,
	"./img_4.png": 670,
	"./img_5.png": 671,
	"./img_6.png": 672,
	"./img_7.png": 673,
	"./img_8.png": 674
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 665;